import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { PERMISSIONS } from "shared/Actions/constants";
import useCanManageStackRoleBindings from "shared/Stack/access/useCanManageStackRoleBindings";
import useTypedContext from "hooks/useTypedContext";
import { StackRoleBindingView } from "shared/Stack/Roles/types";
import { showPreviewPermissionsDrawer } from "components/PreviewPermissions";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageStack } from "hooks/useAnalytics/pages/stack";
import { showStackRoleUnassignConfirmation } from "shared/Stack/Roles/UnassignConfirmation";

import { StackSettingsContextData } from "../../Context";

const refetchQueries = ["StackRoleBindingsWithRoles"];

const StackRolesRowActionsCell = ({
  item: roleBinding,
  ...cellProps
}: TableSimpleCellProps<StackRoleBindingView>) => {
  const { stackSettings } = useTypedContext(StackSettingsContextData);
  const canManageStackRoleBindings = useCanManageStackRoleBindings();
  const canManage = canManageStackRoleBindings(stackSettings);
  const trackSegmentEvent = useAnalytics({
    page: AnalyticsPageStack.StackSettingsRoles,
  });

  const permissions = useMemo(
    () => roleBinding.role.actions.map((action) => PERMISSIONS[action]),
    [roleBinding.role.actions]
  );

  const handlePreviewPermissions = () => {
    showPreviewPermissionsDrawer({
      roleName: roleBinding.role.name,
      permissions,
    });
    trackSegmentEvent("Preview permissions opened");
  };

  const handleUnassign = () => {
    showStackRoleUnassignConfirmation({
      id: roleBinding.id,
      name: roleBinding.role.name,
      refetchQueries,
      source: "table",
    });
  };

  return (
    <TableSimpleCell {...cellProps} stickyRight>
      <DropdownMenuEllipsis tooltip="Role actions">
        <DropdownMenuItem onAction={handlePreviewPermissions}>Preview permissions</DropdownMenuItem>
        <DropdownMenuItem
          danger
          onAction={handleUnassign}
          isDisabled={!canManage.result}
          tooltip={canManage.message}
          isTooltipActive={!!canManage.message}
        >
          Unassign
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default StackRolesRowActionsCell;
